import { render, staticRenderFns } from "./purchaseReturn.vue?vue&type=template&id=23a1a4ca&scoped=true"
import script from "./purchaseReturn.vue?vue&type=script&lang=js"
export * from "./purchaseReturn.vue?vue&type=script&lang=js"
import style0 from "./purchaseReturn.vue?vue&type=style&index=0&id=23a1a4ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a1a4ca",
  null
  
)

export default component.exports